<template>
    <div>
        <Main title="AKG Contracts" subtitle="All AKG Contracts">
            <template v-slot:table>
                <v-app>
                    <div class="row mb-1">
                        <div class="col-md-4 align-self-center">
                            <div class="input-group">
                                <v-text-field
                                    v-model="search.q"
                                    clearable
                                    clear-icon="mdi-close"
                                    type="text"
                                    placeholder="Search by Contract Name"
                                >
                                </v-text-field>
                            </div>
                        </div>
                        <div class="col-1 offset-md-7  align-self-center">
                            <div class="btn-toolbar float-right" role="toolbar">
                                <button class="btn btn-light" type="button" data-toggle="modal" data-target=".sort-modal"><i class="fas fa-sort-amount-up-alt"></i></button>
                                <button class="btn btn-light ml-1" type="button" data-toggle="modal" data-target=".filter-modal"><i class="fas fa-filter"></i></button>
                            </div><!--btn-toolbar-->
                        </div><!--col-->
                    </div>
                    <div class="modal fade sort-modal" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Sort AKG Contracts</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <v-row class="mt-2">
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="search.sortBy"
                                                :items="sorts"
                                                label="Sort By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="search.orderBy"
                                                :items="orders"
                                                label="Order By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="search.itemsPerPage"
                                                :items="perPage"
                                                label="Per Page"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="modal-footer">
                                    <div class="col-md-2 col-2 px-0 text-right">
                                        <v-progress-circular
                                            v-if="search.loading"
                                            :width="2"
                                            :size="30"
                                            indeterminate
                                            color="#fb7e42"
                                            class="mr-2"
                                        ></v-progress-circular>

                                        <button type="button" class="btn btn-light" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade filter-modal" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Filter AKG Contracts</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <v-row class="mt-2">
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="search.status"
                                                :items="statuses"
                                                label="Filter By Status"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="modal-footer">
                                    <div class="col-md-2 col-2 px-0 text-right">
                                        <v-progress-circular
                                            v-if="search.loading"
                                            :width="2"
                                            :size="30"
                                            indeterminate
                                            color="#fb7e42"
                                            class="mr-2"
                                        ></v-progress-circular>

                                        <button type="button" class="btn btn-light" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <TableLoading cols="10" v-if="loading"></TableLoading>
                    <div class="table-responsive mt-4" v-if="!loading">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">ID</span>
                                        </template>
                                        <span>Contract Identifier</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Name</span>
                                        </template>
                                        <span>Contract Name</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Licensor</span>
                                        </template>
                                        <span>Signal Provider</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Licensee</span>
                                        </template>
                                        <span>Platform User</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Status</span>
                                        </template>
                                        <span>Contract Status</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">URL</span>
                                        </template>
                                        <span>Contract URL</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Updated at</span>
                                        </template>
                                        <span>Activation Updated at</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Created at</span>
                                        </template>
                                        <span>Activation Created at</span>
                                    </v-tooltip>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="contract in contracts" class="contract-row">
                                <td>{{ contract.contract_id || '' }}</td>
                                <td>{{ contract.contract_name || '' }}</td>
                                <td>{{ contract.provider_name || 'Intuizi' }}</td>
                                <td>{{ contract.activator_name || '' }}</td>
                                <td>
                                    <span v-if="contract.contract_status === 1" class="badge badge-info">Created</span>
                                    <span v-else-if="contract.contract_status === 2" class="badge badge-warning">In Review</span>
                                    <span v-else class="badge badge-success">Completed</span>
                                </td>
                                <td>
                                    <ShortExternalUrl v-if="contract.contract_file_path" :url="contract.contract_file_path" :text="contract.contract_file_path"></ShortExternalUrl>
                                </td>
                                <td>{{ contract.contract_updated_at || '' }}</td>
                                <td>{{ contract.contract_created_at || '' }}</td>
                            </tr>
                            </tbody>
                        </table>

                        <v-pagination
                            color="#ff7516"
                            v-if="totalPages > 1"
                            v-model="currentPage"
                            :length="totalPages"
                            :total-visible="7"
                        ></v-pagination>

                    </div>
                </v-app>
            </template>
        </Main>
    </div>
</template>

<script>
import Main from '../../components/Main'
import api from "../../api/analyses/akg-contracts";
import mixins from "../../mixin";
import TableLoading from "../../components/general/TableLoading";
import ShortExternalUrl from "../../components/analyses/partials/shared/ShortExternalUrl";

export default {
    name: "AKGContracts",
    mixins: [mixins],
    data: () => ({
        filter: false,
        currentPage: 1,
        totalPages: 1,
        search: {
            q: '',
            sortBy: 'created_at',
            orderBy: 'desc',
            itemsPerPage: 25,
            loading: false,
            status: -1
        },
        sorts: [
            {
                value: 'status',
                text: 'Status'
            },
            {
                value: 'created_at',
                text: 'Last Created'
            },
            {
                value: 'updated_at',
                text: 'Last Updated'
            },
        ],
        statuses: [
            {
                value: -1,
                text: 'All'
            },
            {
                value: 1,
                text: 'Created'
            },
            {
                value: 2,
                text: 'In Review'
            },
            {
                value: 3,
                text: 'Completed'
            },
        ],
        loading: true,
        contracts: [],
    }),
    components: {
        TableLoading,
        Main,
        ShortExternalUrl
    },
    methods: {
        async fetchData() {
            await api.getAllContracts({
                page: this.currentPage,
                total: this.search.itemsPerPage,
                q: this.search.q,
                sortBy: this.search.sortBy,
                orderBy: this.search.orderBy,
                createdBy: this.search.createdBy,
                status: this.search.status
            })
            .then(res => {
                this.contracts = res.data.data.data
                this.currentPage = res.data.pagination.current_page
                this.totalPages = res.data.pagination.last_page
                this.loading = false
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
            })
        },
        filterData: _.debounce(function() {
            this.fetchData()
            this.search.loading = false
        }, 800),
    },
    created() {
        this.fetchData()
    },
    watch: {
        '$store.getters.getCompanyId' : function (val) {
            if (val !== null) {
                window.Echo.private('akg-contracts-' + this.$store.getters.getCompanyId)
                    .listen('Backend\\Contracts\\ContractUpdated', (e) => {
                        this.fetchData()
                    })
            }
        },
        currentPage: function () {
            this.fetchData()
        },
        'search.q': function () {
            if (this.search.q == null) {
                this.search.q = ""
            }
            this.filterData()
        },
        'search.sortBy': function () {
            this.search.loading = true
            this.filterData()
        },
        'search.orderBy': function () {
            this.search.loading = true
            this.filterData()
        },
        'search.itemsPerPage': function () {
            this.search.loading = true
            this.filterData()
        },
        'search.createdBy': function () {
            this.search.loading = true
            this.filterData()
        },
        'search.status': function () {
            this.search.loading = true
            this.filterData()
        },
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
::v-deep .v-application--wrap {
        min-height: fit-content;
    }

button:focus {
    outline:0;
}

.dropdown-corner-radius {
    border-radius: 0.25rem 0 0 0.25rem !important;
}

</style>